import {
    StyleSheet
} from "react-native";
import {
    webStyle
} from "ncore-ui-kit";

const stylesheet = StyleSheet.create({
    companyCard: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center"
    },
    headerContainer: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center"
    },
    footerContainer: {
        justifyContent: "flex-end",
        flexDirection: "row",
        width: "100%"
    },
    logoPlaceholder: {
        justifyContent: "center",
        alignItems: "center",
        height: 100,
        width: 100
    },
    row: {
        flexDirection: "row",
        alignItems: "center"
    },
    container: {
        alignSelf: "center",
        width: "100%",
        maxWidth: 600,
        ...webStyle({
            maxHeight: "90%"
        })
    },
    formContainer: {
        width: "100%"
    },
    positionSelect: {
        height: 50,
        flex: 1
    },
    logoPreview: {
        height: 100,
        width: 100
    },
    sheetContent: {
        height: 500
    },
    newChip: {
    }
});

export default stylesheet;
